import React from 'react';// eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import reactMixin from 'react-mixin';
import styles from './ChangePasswordPage.scss';
import baseComponent from '../../../decorators/baseComponent';
import Context from '../../../Context';
import Header from '../../Header';
import BaseReactComponent from '../../Util/BaseReactComponent';
// import PasswordInput from 'react-password-input';
import Password from 'try-react-password-input';

import {changePassword} from '../../../actioncreators/InstallerCompanyActions';
import {connect} from 'react-redux';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { Form, ValidatedInput } from 'react-bootstrap-validation';

@connect(state => ({
    inprogress: state.login.inprogress
}))
@baseComponent(styles)
@reactMixin.decorate(LinkedStateMixin) class ChangePasswordPage extends BaseReactComponent {

    constructor(props) {
        super(props);

        this.state = {
          newPassword: '',
          newPasswordValid: false
        };
    }

    componentWillMount() {
        //this.props
    }

    keyup(e) {
        if (e.which === 13) {
            this.changePassword(e);
        }
    }

    changePassword = (v) => {
        let self = this;
        if (this.state.newPassword !== v.confirmPassword) {
            this.props.dispatch({
                type: 'CHANGE_PASSWORD_ERROR',
                text: this.getIntlMessage('error.password.dontmatch'),
                level: 'error',
                timeout: 5000
            })
        } else if (this.state.newPassword === v.currentPassword) {
            this.props.dispatch({
                type: 'CHANGE_PASSWORD_ERROR',
                text: this.getIntlMessage('error.password.password-not-changed'),
                level: 'error',
                timeout: 5000
            })
        } else {

            changePassword(v.currentPassword, this.state.newPassword, function (err) {
                if (!err) {
                    self.context.router.push('/');
                }
            })(self.props.dispatch);
        }
    };

    handleNewPasswordChange = (valid, password) => {
      this.setState({
        newPassword: password,
        newPasswordValid: valid
      });
    };

    cancelChange() {
        this.context.router.push('/');
    }

    handleChange(key, event) {
        let update = {};
        update[key] = event.currentTarget.value;
        this.setState(update);
    }

    render() {
        let title = 'Wachtwoord aanpassen';
        Context.getInstance().onSetTitle(title);

        let requestForm = (
            <Form role="form" className="form-horizontal" onKeyPress={this.keyup.bind(this)} onValidSubmit={this.changePassword} >
                <div className="form-group clearfix">
                    <label htmlFor="currentPassword" className="col-sm-2 control-label">{this.getMessage('current-password-label')}</label>

                    <div className="col-sm-6">
                        <ValidatedInput name="currentPassword"
                                        type="password"
                                        className="validate"
                                        id="currentPassword"
                                        validate="required"
                                        errorHelp={{
                                  required: this.getMessage('change-password-current')
                                }}
                            />
                    </div>
                </div>

                <div className="form-group clearfix">
                    <label htmlFor="newPassword" className="col-sm-2 control-label">{this.getMessage('new-password-label')}</label>

                    <div className="col-sm-6" style={{padding: 0}}>

                      <Password uppercase lowercase symbols digits noSpaces min={8} list={false} onChange={this.handleNewPasswordChange} className="new-password-input" />
                    </div>
                </div>
                <div className="form-group clearfix">
                    <label htmlFor="confirmPassword" className="col-sm-2 control-label">{this.getMessage('confirm-password-label')}</label>

                    <div className="col-sm-6">
                        <ValidatedInput name="confirmPassword"
                                        type="password"
                                        className="validate"
                                        id="confirmPassword"
                                        onChange={this.handleChange.bind(this, 'confirmPassword')}
                                        validate="required"
                                        errorHelp={{
                                  required: this.getMessage('change-password-confirm')
                                }}
                            />
                    </div>
                </div>
                <div className="controls">
                    <button className="btn btn-primary" disabled={!this.state.newPasswordValid}>{this.getMessage('save-button')}</button>
                    <a className="btn btn-link" onClick={this.cancelChange.bind(this)}>{this.getMessage('cancel-button')}</a>
                </div>
            </Form>);


        return (
            <div className="ChangePasswordPage">
                <Header pageName="forgotpasswordpage"/>

                <div className="ChangePasswordPage-container">
                    <div className="ChangePasswordPage-header-row">
                        <div className="container">
                            <h1>{this.getMessage('title')}</h1>
                        </div>
                    </div>


                    <div className="container">
                        <br/>
                        <br/>
                        <p>
                          {this.getIntlMessage('changepasswordpage.change-password-description')}
                        </p>


                        <div className="ChangePasswordPage-container-background">
                            {requestForm}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ChangePasswordPage.defaultProps = {
    componentName: 'changepasswordpage'
};

export default ChangePasswordPage;




// WEBPACK FOOTER //
// /src/components/PasswordPage/ChangePasswordPage/ChangePasswordPage.js